import Vue from "vue";
import moment from "moment";
import CXMApiClient from "../CXMApiClient";
import { csv } from "../../lib/utilities/HelperFunctions";
import { AccountProductFeature, Product } from "@/lib/utilities/enums";

function initialLoad() {
  return {
    CallTrackingDashboardFilters: [],
    CallTrackingDashboardCounts: [],
    CallTrackingDashboardResults: [],
    CallTrackingDashboardPagination: {
      pageTotal: 0,
      pageNumber: 1,
      pageSize: 25,
      totalRecords: 0
    },
    CTC_CountsLoading: false,
    CTC_ResultsLoading: false,
    CallTrackingSettingsLoaded: false,
    SourcesForCallTrackingDashboard: [],
    ExportInProgress: false,
    ClickToCallModalInfo: {
      showModal: false,
      data: null
    },
    CallTrackingEnabledStoresAndProviders: []
  };
}

const state = initialLoad();

const getStores = (storeFeatureList, storeList, [productID, featureID]) =>
  storeFeatureList
    .filter(
      vap =>
        vap &&
        vap.ProductID == productID &&
        vap.Features.find(
          feat => feat && feat.Active && feat.FeatureID == featureID
        )
    )
    .map(vap =>
      storeList.find(
        vss => vss && vss.AccountPlatformID == vap.AccountPlatformID
      )
    )
    .filter(vss => vss)
    .sort((a, b) => {
      return a.Name && b.Name && a.Name.toLowerCase() > b.Name.toLowerCase()
        ? 1
        : -1;
    });

const actions = {
  fetchCallTrackingDashboardCounts: function(context, request) {
    context.commit("toggleLoadingIndicatorForCounts", true);
    return new Promise((resolve, reject) => {
      request.CallTrackingtatusIds = [];
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/calltracking/dashboard/get_call_tracking_counts",
          request
        )
        .then(response => {
          context.commit(
            "updateCallTrackingDashboardCounts",
            response.data && response.data.data ? response.data.data : null
          );
          context.commit("toggleLoadingIndicatorForCounts", false);
          if (response.data && response.data.successful) resolve(response);
          else reject(response);
        })
        .catch(function(error) {
          context.commit("toggleLoadingIndicatorForCounts", false);
          reject(error);
        });
    });
  },
  fetchCallTrackingDashboardResults: function(context, request) {
    context.commit("toggleLoadingIndicatorForSearch", true);
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/calltracking/dashboard/search", request)
        .then(response => {
          context.commit(
            "updateCallTrackingDashboardResults",
            response.data && response.data.data ? response.data.data : []
          );
          context.commit("toggleLoadingIndicatorForSearch", false);
          if (response.data && response.data.successful) resolve(response.data);
          else reject(response);
        })
        .catch(function(error) {
          context.commit("toggleLoadingIndicatorForSearch", false);
          reject(error);
        });
    });
  },
  loadUnmatchedCalls: function(context, request) {
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "POST",
          "/dashboard/get_unmatched_calls_data",
          request,
          request
        )
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  assignLoggedByUser: function(context, request) {
    context.commit("toggleLoadingIndicatorForCounts", true);
    return new Promise((resolve, reject) => {
      request.CallTrackingtatusIds = [];
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/call_tracking/dashboard/assign_logged_by_user",
          request
        )
        .then(response => {
          context.commit("toggleLoadingIndicatorForCounts", false);
          if (response.data && response.data.successful) resolve(response);
          else reject(response);
        })
        .catch(function(error) {
          context.commit("toggleLoadingIndicatorForCounts", false);
          reject(error);
        });
    });
  },
  matchCallLogEntry: function(context, request) {
    context.commit("toggleLoadingIndicatorForCounts", true);
    return new Promise((resolve, reject) => {
      //request.CallTrackingtatusIds = [];
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/dashboard/match_call_log_entry", request)
        .then(response => {
          // context.commit(
          //   "updateCallTrackingDashboardCounts",
          //   response.data && response.data.data ? response.data.data : null
          // );
          context.commit("toggleLoadingIndicatorForCounts", false);
          if (response.data) resolve(response);
          else reject(response);
        })
        .catch(function(error) {
          context.commit("toggleLoadingIndicatorForCounts", false);
          reject(error);
        });
    });
  },
  getCallTrackingExportResults: function(context, request) {
    context.commit("updateExportLoadingStatus", true);
    return new Promise((resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("POST", "/api/calltracking/dashboard/export", request)
        .then(response => {
          context.commit("updateExportLoadingStatus", false);
          if (response && response.data && response.status == 200) {
            // let replaceFalse = response.data.replaceAll("False", "No");
            // let replaceTrue = replaceFalse.replaceAll("True", "Yes");
            // response.data = replaceTrue;
            resolve(csv.processCSV(response));
          } else reject(response);
        })
        .catch(function(error) {
          context.commit("updateExportLoadingStatus", false);
          reject(error);
        });
    });
  },
  async getCallTrackingSettings(context) {
    let response = await new CXMApiClient().ProcessRequest(
      "GET",
      `/api/calltracking/get_dealer_settings_by_account?accountId=${context.getters.User.ViewAccountID}&onlyDealersWithCallTrackingFeature=true`
    ).catch(err => err.response);
    if (response && response.data)
      context.commit("updateCallTrackingStoresAndVendors", {
        results: response.data.data,
        storeIds: context.getters.User.ViewSelectedStores.map(vss => vss.AccountPlatformID)
      });
  },
  updateCallTrackingDashboardCounts: function(context, data) {
    context.commit("updateCallTrackingDashboardCounts", data);
  },
  updateCallTrackingDashboardResults: function(context, data) {
    context.commit("updateCallTrackingDashboardResults", data);
  },
  updateCallTrackingDashboardPagination: function(context, data) {
    context.commit("updateCallTrackingDashboardPagination", data);
  },
  toggleLoadingIndicatorForCounts: function(context, data) {
    context.commit("toggleLoadingIndicatorForCounts", data);
  },
  toggleLoadingIndicatorForSearch: function(context, data) {
    context.commit("toggleLoadingIndicatorForSearch", data);
  },
  updateCallTrackingDashboardFilters: function(context, request) {
    context.commit("updateCallTrackingDashboardFilters", request);
  },
  updateSourcesForCallTrackingDashboard: function(context, data) {
    context.commit("updateSourcesForCallTrackingDashboard", data);
  },
  updateClickToCallModalInfo: function(context, data) {
    context.commit("updateClickToCallModalInfo", data);
  }
};

const mutations = {
  updateCallTrackingDashboardCounts: function(state, data) {
    state.CallTrackingDashboardCounts = data;
  },
  updateCallTrackingDashboardResults: function(state, data) {
    state.CallTrackingDashboardResults = data;
  },
  toggleLoadingIndicatorForCounts: function(state, data) {
    state.CTC_CountsLoading = data;
  },
  toggleLoadingIndicatorForSearch: function(state, data) {
    state.CTC_ResultsLoading = data;
  },
  updateCallTrackingDashboardFilters: function(state, data) {
    state.CallTrackingDashboardFilters = data;
  },
  updateSourcesForCallTrackingDashboard: function(state, data) {
    state.SourcesForCallTrackingDashboard = data;
  },
  updateExportLoadingStatus: function(state, data) {
    state.exportInProgress = data;
  },
  updateClickToCallModalInfo: function(state, data) {
    state.ClickToCallModalInfo = data;
  },
  updateCallTrackingStoresAndVendors(state, data) {
    state.CallTrackingEnabledStoresAndProviders = (data.results || []).filter(result => data.storeIds.includes(result.accountPlatformId));
    state.CallTrackingSettingsLoaded = true;
  }
};

const getters = {
  CallTrackingSettingsLoaded: function(state) {
    return state.CallTrackingSettingsLoaded;
  },
  IsCallTrackingEnabled: function(state) {
    return state.CallTrackingEnabledStoresAndProviders && state.CallTrackingEnabledStoresAndProviders.length > 0;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/CallTrackingDashboard.js